
import { FormFilter, ViewFilter } from './styled'
import { FaFilter } from 'react-icons/fa';
import { useEffect, useState } from 'react';
import { FormGroupCustom, FormLabelCustom } from '../Filters/style';
import SelectWithSearch from '../../../../Components/SelectWithSearch';
import { getAllServices } from '../../../../services/flow';
import { getOrganDataList } from '../../../../services/organ';


interface ServicoSlug {
  label: string;
  value: string;
}

type InpuSearchProps = {
  setFilter?: (value: string) => void;
  searchData?: string;
  isSearch?: boolean;
  handleResetInputSearch?: () => void;
  setSearchData?: (value: string) => void;
  setFilters?: any;
  onShowFilters: () => void;
  setServicoSlug: (slug: ServicoSlug) => void;
  fetchData: any;
  filters: any;
  setSearch;
  isRequestsTab?: boolean;
}

const InpuSearch = ({
  searchData,
  filters,
  setFilters,
  setServicoSlug,
  onShowFilters,
  isRequestsTab = false
}: InpuSearchProps) => {
  const [localSearch, setLocalSearch] = useState(searchData);
  const [servicesList, setServicesList] = useState<any>(null);
  const [serviceSelected, setServiceSelected] = useState<any>(null);
  const [service, setService] = useState<any>(null);
  const [loadingServico, setLoadingServico] = useState<boolean>(false);
  const [orgaoList, setOrgaoList] = useState<any>(null);
  const [loadingOrgao, setLoadingOrgao] = useState<boolean>(false);
  const [orgaoAll, setOrgaoAll] = useState<any>();
  const [organSelected, setOrgaoSelected] = useState<number>(0);
  const [organSlugSelected, setOrgaoSlugSelected] = useState<string>('');
  const [orgao, setOrgao] = useState<any>(null);

  useEffect(() => {
    setLocalSearch(searchData);
  }, [searchData]);

  const onRemoveServiceValues = () => {
    setServicesList([]);
    setServiceSelected('');
    setService(null);
  }

  const handleSelectService = (value: { label: string, value: string } | null) => {
    if (value) {
      setServiceSelected(value.value);
      setService(value);
      setServicoSlug({ label: value.label, value: value.value });
    } else {
      setServiceSelected('');
      setService({ label: '', value: '' });
      setServicoSlug({ label: '', value: '' });
    }
  }


  const setOrgaoValueFormatted = (values) => {
    if (values) {
      let orgaoOptions = values.map((value) => ({
        label: value.nome,
        value: value.slug,
      }));
      setOrgaoList(orgaoOptions);
    }
  }

  const setServicoValueFormatted = (values) => {
    if (values) {
      let serviceOptions = values.map((value) => ({
        label: value.titulo,
        value: value.slug,
      }));
      setServicesList(serviceOptions);
      if (serviceSelected) {
        const service = handleGetById(serviceSelected, serviceOptions);
        if (service?.length) {
          setService({ label: service[0].label, value: service[0].value });
        }
      }
    }
  }

  const getServices = async (orgaoSlug?: string) => {
    setLoadingServico(true);
    try {
      const { data } = await getAllServices(orgaoSlug, !isRequestsTab);
      if (data) {
        setServicoValueFormatted(data);
        return data;
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingServico(false);
    }
  }

  const handleSelectOrgao = (value: { label: string, value: string } | null) => {
    if (value) {
      let [orgao] = handleGetById(value.value, orgaoAll);
      setOrgao(value);
      setOrgaoSelected(orgao.id);
      setOrgaoSlugSelected(orgao.slug);
      setFilters({ ...filters, organSelected: orgao.id });
      onRemoveServiceValues();
      getServices(orgao.slug);
    } else {
      setOrgao({ label: '', value: '' });
      setOrgaoSelected(0);
      setOrgaoSlugSelected('');
      setFilters({ ...filters, organSelected: 0, sertiveSlug: { label: '', value: '' } });
      setServiceSelected('');
      setService({ label: '', value: '' });
      setServicoSlug({ label: '', value: '' });
      getServices();
    }
  }

  useEffect(() => {
    if (organSelected && organSlugSelected) {
      getServices(organSlugSelected);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organSelected, organSlugSelected]);


  useEffect(() => {
    const getOrgans = async () => {
      const tokenSSO: string | null = localStorage.getItem('gov_access_token');
      try {
        setLoadingOrgao(true);
        const { data } = await getOrganDataList(tokenSSO);
        if (data) {
          setOrgaoValueFormatted(data);
          setOrgaoAll(data);
        }

      } catch (error) {
        console.log(error);

      } finally {
        setLoadingOrgao(false);
      }
    };
    getOrgans();
  }, []);

  const handleGetById = (slug: string, items: any) => {
    if (slug) {
      return items.filter((item) => item.slug === slug);
    }
  }

  return (
    <FormFilter>
      <ViewFilter onClick={() => onShowFilters()} disabled={!servicesList?.length || loadingServico}>
        <FaFilter color='#264259' />
        Filtros
      </ViewFilter>

      <FormGroupCustom style={{ width: '350px' }}>
        <FormLabelCustom>
          Órgão
        </FormLabelCustom>
        <SelectWithSearch
          name='orgao'
          options={orgaoList}
          isDisabled={!orgaoList || loadingOrgao}
          value={orgao}
          onChange={handleSelectOrgao}
          placeholder="Selecione ou digite o nome do órgão"
          isClearable
        />
      </FormGroupCustom>

      <FormGroupCustom style={{ width: '350px' }}>
        <FormLabelCustom>
          Serviços
        </FormLabelCustom>
        <SelectWithSearch
          name='servicos'
          value={service}
          isDisabled={!servicesList?.length || loadingServico}
          onChange={handleSelectService}
          options={servicesList}
          placeholder="Selecione ou digite o nome do serviço"
          isClearable
        />
      </FormGroupCustom>
    </FormFilter >
  )
}

export default InpuSearch